export const COMMIT_HASH = "7c06987ea823c54d39f934f81691c569bde3250c";
export const SHORTBREAD_VERSION = "1.1.1";
